import type { JSXElementConstructor, ReactElement } from 'react';

import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent.ts';

import { useDeepCompareEffect } from '../useDeepCompareEffect.ts';
import { getMacroExperienceTracker } from '../MacroExperienceTracker.ts';

export type MacroExperienceFailureProps = {
	error: Error;
	mode: string;
	onFailure?: () => void;
	attributes: ExperienceAttributes;
	extensionKey?: string;
	name: string;
	children?: ReactElement | null;
	contentId: string;
	source?: string;
};

export function MacroExperienceFailure({
	attributes,
	children = null,
	contentId,
	extensionKey,
	error,
	mode,
	name,
	source,
}: MacroExperienceFailureProps): ReactElement<any, string | JSXElementConstructor<any>> | null {
	useDeepCompareEffect(() => {
		getMacroExperienceTracker(mode, contentId).fail({
			name,
			attributes: {
				...attributes,
				source,
			},
			error,
		});
	}, [attributes, contentId, extensionKey, error, mode, name, source]);

	return children;
}
